import { BellRing } from 'lucide-react'
import { useIsMobile } from '@/hooks'
import LoadingButton from '@/components/custom/loading-button'
import { useNotifyUnmatchedDonors } from '@/features/navbar/hooks/useServiceConfig'
import { useDonationsStore } from '@/features/donations/store/donationsStore'

const NotifyUnmatchDonationsButton = () => {
  const isMobile = useIsMobile()
  const { mutateAsync: notifyUnmatchedDonors, isPending: isNotifying } =
    useNotifyUnmatchedDonors()

  const donations = useDonationsStore((s) => s.donations)

  const unmatchedDonations = donations.filter(
    (donation) => !donation.donorId || !donation.churchId,
  )

  const handleClick = async () => {
    try {
      await notifyUnmatchedDonors()
    } catch (error) {
      console.error('Error notifying unmatched donors', error)
    }
  }

  if (unmatchedDonations.length === 0) return null

  // Button is always shown, since receipts are fetched server-side
  return (
    <LoadingButton
      className={`text-xs ${isMobile ? 'w-full justify-center' : 'ml-2'}`}
      onClick={handleClick}
      disabled={isNotifying}
      isLoading={isNotifying}
    >
      <BellRing className="h-4 w-4" />
      {isNotifying ? 'Processing...' : 'Notify Treasurers (Unassigned)'}
    </LoadingButton>
  )
}
export default NotifyUnmatchDonationsButton
